import type { GridMapboxStyle } from './styles';

export const gridsCounty = (style: GridMapboxStyle) => [
  {
    minzoom: 7,
    layout: {
      'text-field': ['get', 'label'],
      'text-size': style.textSize,
      'text-allow-overlap': false,
      'text-ignore-placement': false,
      visibility: 'visible',
    },
    type: 'symbol',
    id: 'county-labels',
    paint: {
      'text-color': style.textColor,
      ...(style.textHaloColor &&
        style.textHaloWidth && {
          'text-halo-color': style.textHaloColor,
          'text-halo-width': style.textHaloWidth,
        }),
    },
    source: 'grids',
    'source-layer': 'county_centers',
  },
  {
    minzoom: 7,
    type: 'line',
    id: 'county-grid',
    paint: {
      'line-color': style.lineColor,
      'line-width': style.lineWidth,
    },
    source: 'grids',
    'source-layer': 'county',
    layout: {
      visibility: 'visible',
    },
  },
];
